import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M16.373 7.992c.946 1.141 1.676 2.616 1.676 4.055 0 1.841-.793 3.499-2.056 4.648M7.593 7.965c-.958 1.144-1.698 2.632-1.698 4.082a6.27 6.27 0 0 0 1.998 4.596"
    />
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M2 12.253c.882 1.033 4.821 5.285 9.995 5.285 5.351 0 9.16-4.256 10.005-5.286"
    />
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M22 12.295C21.137 11.281 17.187 7 11.995 7 6.662 7 2.862 11.227 2 12.275"
    />
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M11.876 14.066a1.678 1.678 0 1 0 0-3.355 1.678 1.678 0 0 0 0 3.355Z"
    />
  </svg>
);
export const EyeIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
